import React from "react";

function Bio() {
  return (
    <React.Fragment>
      <div class="container">
        <div class="w-75 mx-auto mt-5 text-center lh-lg">
          حاصل ثامر السويط على بكالوريوس هندسة معمارية من جامعة ميلواكي في ولاية
          وسكنسن الأمريكية وعمل خبير هندسي بإدارة الخبراء بوزارة العدل وعمل
          مُهندسًا في وزارة الأشغال وعضو جمعية المهندسين الكويتية و نال على
          عضوية مجلس الأمة
          <div className="text-center h5 my-3">2016-2020-2022</div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Bio;
